import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { ArticulosDepositoContext } from '../../../context/articulosDeposito/ArticulosDepositoContext';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Paginator } from '../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from '../../../components/Title';
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";
import ModalInformes from '../../../components/Imprimir/ModalImpresion';
import { FaFileDownload } from 'react-icons/fa';
export const Datatable = ({
  onSelect,
  onClose,
  tipoprecio,
  idSelectorDepo=null,
  findNoCombo = false,
  enableCreate = true,
  disableSelection,
  enableCheckboxSelection,
  enableSelectionClick,
  enableSelectionFinder,
  tipovista = "conStock",
  viewInformes = true
}) => {
  const titleGrid = "Existencias de Artículos";
  useDocumentTitle(titleGrid);
  const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(ArticulosDepositoContext);
  const { empresaData } = useContext(AuthContext);
  const
    { getArticulosExistenciaPanelData }
      = contexto;
  const navigate = useNavigate();

  const nameData = "articulos";
  const getData = getArticulosExistenciaPanelData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState("");
  const searchSelectRef = useRef();
  const searchSelectStockRef = useRef();
  const searchSelectOrderRef = useRef();
  const searchSelectOrderByRef = useRef();
  const [searchIDDepo, setSearchIDDepo] = useState();
  const [searchIDRam, setSearchIDRam] = useState();
  const [searchIDRub, setSearchIDRub] = useState();
  const [searchIDSubr, setSearchIDSubr] = useState();
  const [searchIDMar, setSearchIDMar] = useState();
  const [searchDescDepo, setSearchDescDepo] = useState();
  const [searchDescRam, setSearchDescRam] = useState();
  const [searchDescRub, setSearchDescRub] = useState();
  const [searchDescSubr, setSearchDescSubr] = useState();
  const [searchDescMar, setSearchDescMar] = useState();
  const [searchDes, setSearchDes] = useState();
  const [searchStock, setSearchStock] = useState();
  const [selectOrderBy, setSelectOrderBy] = useState();
  const [selectOrder, setSelectOrder] = useState();
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  // Estado para impresion
  const [dataImpresion, setDataImpresion] = useState(null);
  const [openModalInformes, setOpenModalInformes] = useState(false);
  //Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "articulosDeposito";
  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchTerm: "",
    searchIDDepo: "",
    searchDescDepo: "",
    searchIDRam: "",
    searchDescRam: "",
    searchIDRub: "",
    searchDescRub: "",
    searchIDSubr: "",
    searchDescSubr: "",
    searchIDMar: "",
    searchDescMar: "",
    searchDes: "",
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchTerm(savedFilters.searchTerm || "");
      setSearchIDDepo(savedFilters.searchIDDepo || "");
      setSearchDescDepo(savedFilters.searchDescDepo || "");
      setSearchIDRam(savedFilters.searchIDRam || "");
      setSearchDescRam(savedFilters.searchDescRam || "");
      setSearchIDRub(savedFilters.searchIDRub || "");
      setSearchDescRub(savedFilters.searchDescRub || "");
      setSearchIDSubr(savedFilters.searchIDSubr || "");
      setSearchDescSubr(savedFilters.searchDescSubr || "");
      setSearchIDMar(savedFilters.searchIDMar || "");
      setSearchDescMar(savedFilters.searchDescMar || "");
      setSearchDes(savedFilters.searchDes || "");
      setNumPagina(savedFilters.numPagina || 1);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, viewInformes, searchTerm, searchIDDepo, searchDescDepo, searchIDRam, searchDescRam, searchIDRub, searchDescRub, searchIDSubr, searchDescSubr, searchIDMar, searchDescMar, searchDes, searchStock, numPagina, filas, selectOrderBy, selectOrder]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchTerm,
      searchIDDepo,
      searchDescDepo,
      searchIDRam,
      searchDescRam,
      searchIDRub,
      searchDescRub,
      searchIDSubr,
      searchDescSubr,
      searchIDMar,
      searchDescMar,
      searchDes
    };
    updateFilters(pageKey, updatedFilters);
  };

  useEffect(() => {
    if (idSelectorDepo) {
      setSearchIDDepo(idSelectorDepo);
      fetchData(); // Ejecuta fetchData para reflejar inmediatamente el cambio
    }
  }, [idSelectorDepo]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getData(
          searchTerm,
          searchIDDepo|| idSelectorDepo || "",
          searchIDRam,
          searchIDRub,
          searchIDSubr,
          searchIDMar,
          searchDes,
          searchStock,
          1,
          totalItems,
          selectOrderBy,
          selectOrder
        );
        setDataImpresion(result);
      } catch (error) {
        console.error("Error al cargar datos de impresión:", error);
      }
    };

    fetchData();
  }, [searchTerm, idSelectorDepo, searchIDDepo, searchIDRam, searchIDRub, searchIDSubr, searchIDMar, searchDes, searchStock, totalItems, selectOrderBy, selectOrder]);


  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage, totalDataItems } = await fetchEntityData(
        getData,
        searchTerm,
        searchIDDepo || idSelectorDepo || "",
        searchIDRam,
        searchIDRub,
        searchIDSubr,
        searchIDMar,
        searchDes,
        searchStock,
        numPagina,
        filas,
        selectOrderBy,
        selectOrder,
        findNoCombo,
      );

         
      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };
  const handleDesChange = (e) => {
    const value = e.target.value;
    setSearchDes(value);
  };
  const handleStockChange = (e) => {
    const value = e.target.value;
    setSearchStock(value);
  };
  const handleOrderByChange = (e) => {
    const value = e.target.value;
    setSelectOrderBy(value);
  };
  const handleOrderChange = (e) => {
    const value = e.target.value;
    setSelectOrder(value);
  };
  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const handleSearch = () => {
    const value = searchInputRef.current?.value || ""; // Obtiene el valor del input
    setSearchTerm(value); // Actualiza el estado con el término de búsqueda
  };

  const handleClear = () => {
    setSearchTerm("");
    if (searchInputRef.current) {
      searchInputRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const handleClearDes = () => {
    setSearchDes("");
    if (searchSelectRef.current) {
      searchSelectRef.current.value = ""; // Limpia el input de búsqueda
    }
  };
  const handleClearStock = () => {
    setSearchStock("");
    if (searchSelectStockRef.current) {
      searchSelectStockRef.current.value = ""; // Limpia el input de búsqueda
    }
  };
  const handleClearOrderBy = () => {
    setSelectOrderBy("");
    if (searchSelectOrderByRef.current) {
      searchSelectOrderByRef.current.value = ""; // Limpia el input de búsqueda
    }
  };
  const handleClearOrder = () => {
    setSelectOrder("");
    if (searchSelectOrderRef.current) {
      searchSelectOrderRef.current.value = ""; // Limpia el input de búsqueda
    }
  };


  const handleRowClick = (params) => {
    const selectedId = params.row.idarticulo; // Capturar el id del Cliente
    const selectedCod = params.row.codigo;
    const selectedDesc = params.row.descripcion;
    const selectedCos = params.row.preciocosto;
    const selectedMay = params.row.preciomayorista;
    const selectedMin = params.row.preciominorista;
    onSelect && onSelect(selectedId, selectedDesc, selectedCod, selectedCos, selectedMay, selectedMin); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  const headersArt = getHeaders(tipovista).filter((column) => {
    if (Number(tipoprecio) === 1 && (column.field === "preciominorista" || column.field === "preciocosto")) {
      return false; // Oculta P. Minorista y P. Costo para tipo precio 0
    }
    if (Number(tipoprecio) === 0 && (column.field === "preciomayorista" || column.field === "preciocosto")) {
      return false; // Oculta P. Mayorista y P. Costo para tipo precio 1
    }
    return true; // Muestra las demás columnas
  });

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headersArt.filter((column) => !column.hidden));
    return commonCols;
  }, [onSelect, numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems, tipovista), [listaItems]);

  const visibleFields = headersArt
    .filter(col => !col.hidden)
    .map(col => col.field);

  const rowsData = useMemo(() => {
    if (!dataImpresion || !dataImpresion.products) return [];
    return formatRows(dataImpresion.products, tipovista);
  }, [dataImpresion, tipovista]);

  const datosColumAjuste = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(
      headersArt.filter((column) => !column.hidden)
    );

    // Agregar columna Stock Relevado solo para exportar o visualizar en PDF
    const stockRelevadoCol = {
      field: "stockRelevado",
      headerName: "Reelevado",
      width: 100, // Ajustá el ancho si lo necesitás
    };

    return [...commonCols, stockRelevadoCol];
  }, [onSelect, numPagina, filas]);

  const filtersImpresion = useMemo(() => {
    return [
      { descripcion: 'Búsqueda', valor: searchTerm },
      { descripcion: 'Depósito', valor: searchDescDepo },
      { descripcion: 'Rama', valor: searchDescRam },
      { descripcion: 'Rubro', valor: searchDescRub },
      { descripcion: 'Subrubro', valor: searchDescSubr },
      { descripcion: 'Marca', valor: searchDescMar },
      { descripcion: 'Descripción', valor: searchDes },
      {
        descripcion: 'Stock',
        valor:
          Number(searchStock) === 0
            ? 'CON STOCK'
            : Number(searchStock) === 1
              ? 'SIN STOCK'
              : null
      },
      { descripcion: 'Ordenado por', valor: selectOrderBy },
      { descripcion: 'Orden', valor: selectOrder }
    ].filter(
      f =>
        f.valor !== null &&
        f.valor !== undefined &&
        f.valor !== '' &&
        typeof f.valor !== 'object'
    );
  }, [
    searchTerm,
    searchDescDepo,
    searchDescRam,
    searchDescRub,
    searchDescSubr,
    searchDescMar,
    searchDes,
    searchStock,
    selectOrderBy,
    selectOrder
  ]);

  const rowsImpresion = useMemo(() => {
    return rowsData.map(row => {
      const filteredRow = {};
      visibleFields.forEach(key => {
        filteredRow[key] = row[key];
      });
      return filteredRow;
    });
  }, [rowsData, visibleFields]);

  const rowsImpresionAjuste = useMemo(() => {
    return rowsData.map(row => {
      const filteredRow = {};
      visibleFields.forEach(key => {
        filteredRow[key] = row[key];
      });
      // Agregar Stock Relevado para el PDF
      filteredRow["stockRelevado"] = row["stockRelevado"] || ''; // puede ser 0 si preferís
      return filteredRow;
    });
  }, [rowsData, visibleFields]);

  const handleSelectionChange = (selectedIds) => {
    setSelectedItems(selectedIds);
  };

  const handleConfirmSelection = (selectedRows) => {
    onSelect && onSelect(selectedRows); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };
  const onConfirmSelection = (selectedRows) => {
    onSelect && onSelect(selectedRows); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  const informesConfig = [
    {
      headers: datosColum,
      rows: rowsImpresion,
      filters: filtersImpresion,
      title: "Informe de Existencias",
      tipo: "both",
    },
    {
      headers: datosColumAjuste,
      rows: rowsImpresionAjuste,
      filters: filtersImpresion,
      title: "Planilla de Ajuste",
      tipo: "solopdf",
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle" style={{ position: 'sticky', top: 0, padding: '10px 0' }}>

        <h3>{titleGrid}</h3>
        {viewInformes && (
          <button
            onClick={() => setOpenModalInformes(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: '#2563eb', // azul
              color: 'white',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
            }}
          >
            <FaFileDownload size={18} />
            <span>Informes</span>
          </button>
        )
        }

        <FiltersGrid
          searchInputRef={searchInputRef}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onSearch={handleSearch}
          onClose={handleClear}
          setSearchIDMar={setSearchIDMar}
          setSearchDescMar={setSearchDescMar}
          setSearchIDRam={setSearchIDRam}
          setSearchDescRam={setSearchDescRam}
          setSearchIDRub={setSearchIDRub}
          setSearchDescRub={setSearchDescRub}
          setSearchIDSubr={setSearchIDSubr}
          setSearchDescSubr={setSearchDescSubr}
          setSearchIDDepo={setSearchIDDepo}
          setSearchDescDepo={setSearchDescDepo}
          searchIDDepo={searchIDDepo}
          searchIDRam={searchIDRam}
          searchIDRub={searchIDRub}
          selectRef={searchSelectRef}
          selectStockRef={searchSelectStockRef}
          selectOrderByRef={searchSelectOrderByRef}
          selectOrderRef={searchSelectOrderRef}
          searchDes={searchDes}
          searchStock={searchStock}
          selectOrderBy={selectOrderBy}
          selectOrder={selectOrder}
          handleDesChange={handleDesChange}
          handleClearDes={handleClearDes}
          handleStockChange={handleStockChange}
          handleClearStock={handleClearStock}
          handleOrderByChange={handleOrderByChange}
          handleClearOrderBy={handleClearOrderBy}
          handleOrderChange={handleOrderChange}
          handleClearOrder={handleClearOrder}
          idSelectorDepo={idSelectorDepo}
        />
        {
          enableCreate &&
          <div className="linkContainer">
          </div>
        }
      </div>
      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">

            <div className="iconosWrapper">

              <ModalInformes
                open={openModalInformes}
                onClose={() => setOpenModalInformes(false)}
                informes={informesConfig}
                empresa={empresaData}
              />
            </div>
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onRowClick={handleRowClick}
              onSelectionChange={handleSelectionChange}
              onConfirmSelection={handleConfirmSelection}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
              disableSelection={disableSelection}
              enableCheckboxSelection={enableCheckboxSelection}
              enableSelectionFinder={enableSelectionFinder}
              enableSelectionClick={enableSelectionClick}
            />
          </div>

          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>

        </>
      )}
    </div>

  );
};
Datatable.propTypes = {
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  tipoprecio: PropTypes.number,
};
Datatable.defaultProps = {
  tipoprecio: 2,
};
export default Datatable;
